const gender = [
    "Select from the following...",
    "Female",
    "Male"
]

export default gender